export const MOBILE_MEDIA_QUERY = '(max-width: 767.98px)';
export const DESKTOP_MEDIA_QUERY = '(min-width: 768px)';
